import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";

interface Props {
  isRequired?: boolean;
  typo?: string;
  style?: React.CSSProperties;
}

const Label: React.FC<Props> = ({ isRequired, style, typo, children }) => {
  return (
    <StyledLabelWrapper style={style} typo={typo}>
      {children}
      <StyledOptionalStar>{isRequired && "*"}</StyledOptionalStar>
    </StyledLabelWrapper>
  );
};
const StyledLabelWrapper = styled.div<Props>`
  display: flex;
  flex-wrap: nowrap;
  ${(props) => props.typo || theme.typo.heading.b16};
  min-width: fit-content;
  margin-bottom: 16px;
`;
const StyledOptionalStar = styled.div`
  color: #e60000;
  padding-left: 4px;
`;
export default Label;
